import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContinuousCarousel from "../../components/ContinuousCarousel/ContinuousCarousel";
import AboutStorySection from "../../components/AboutStorySection/AboutStorySection";
import OurProductsSection from "../../components/OurProductsSection/OurProductsSection";

import heroImage from "../../assets/AboutPage/AboutImage.png";
import storyImg from "../../assets/AboutPage/story_rama3.png";

import Carousel1 from "../../assets/CarouselPersonalizate/49.jpg";
import Carousel2 from "../../assets/CarouselPersonalizate/54.jpg";
import Carousel3 from "../../assets/CarouselPersonalizate/55.jpg";
import Carousel4 from "../../assets/CarouselPersonalizate/74.jpg";
import Carousel5 from "../../assets/CarouselPersonalizate/85.jpg";
import Carousel6 from "../../assets/CarouselPersonalizate/102.jpg";
import Carousel7 from "../../assets/CarouselPersonalizate/125.jpg";
import Carousel8 from "../../assets/CarouselPersonalizate/129.jpg";
import Carousel9 from "../../assets/CarouselPersonalizate/133.jpg";
import Carousel10 from "../../assets/CarouselPersonalizate/135.jpg";
import Carousel11 from "../../assets/CarouselPersonalizate/166.jpg";
import Carousel12 from "../../assets/CarouselPersonalizate/174.jpg";
import Carousel13 from "../../assets/CarouselPersonalizate/180.jpg";
import Carousel14 from "../../assets/CarouselPersonalizate/219.jpg";
import Carousel15 from "../../assets/CarouselPersonalizate/226.jpg";
import Carousel16 from "../../assets/CarouselPersonalizate/44.jpg";
import Carousel17 from "../../assets/CarouselPersonalizate/39.jpg";

const carouselItems = [
  { id: 1, image: Carousel1 },
  { id: 2, image: Carousel2 },
  { id: 3, image: Carousel3 },
  { id: 4, image: Carousel4 },
  { id: 5, image: Carousel5 },
  { id: 6, image: Carousel6 },
  { id: 7, image: Carousel7 },
  { id: 8, image: Carousel8 },
  { id: 9, image: Carousel9 },
  { id: 10, image: Carousel10 },
  { id: 11, image: Carousel11 },
  { id: 12, image: Carousel12 },
  { id: 13, image: Carousel13 },
  { id: 14, image: Carousel14 },
  { id: 15, image: Carousel15 },
  { id: 16, image: Carousel16 },
  { id: 17, image: Carousel17 },
];

import { Page, Container, FullImageHero, HeroImage } from "./AboutPageStyles";

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <Page>
      <FullImageHero>
        <HeroImage src={heroImage} alt="Ahava Cakes" />
      </FullImageHero>

      <Container>
        <AboutStorySection
          imageSrc={storyImg}
          primaryCta={{
            label: "Vezi produse",
            onClick: () => navigate("/"),
          }}
        />

        <OurProductsSection
          title="Produsele noastre"
          subtitle="Descoperă ce înseamnă dulcele făcut cu suflet"
          description="Fie că îți dorești un tort de nuntă spectaculos, o prăjitură fină pentru un eveniment special sau un desert personalizat care să vorbească în locul tău, aici găsești o echipă care înțelege importanța detaliilor și emoția din spatele fiecărei comenzi."
        />

        <ContinuousCarousel
          title="Torturi Premium Personalizate"
          subtitle="Eleganță în fiecare strat"
          description={
            <>
              O petrecere fără tort este doar o simplă întâlnire. La{" "}
              <strong>Ahava Cakes</strong>, torturile noastre transformă orice
              ocazie într-un moment memorabil. Fiecare creație prinde viață din
              dorințele tale – alegi <strong>dimensiunea</strong>,{" "}
              <strong>designul</strong> și <strong>aromele</strong>, iar noi le
              împletim cu grijă pentru a transforma un desert într-o{" "}
              <strong>amintire care rămâne</strong>.
            </>
          }
          items={carouselItems}
        />
      </Container>
    </Page>
  );
}
